function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 386,
  cy: 210,
  r: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M432 40h-26V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20h-91V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20h-90V20c0-11.046-8.954-20-20-20s-20 8.954-20 20v20H80C35.888 40 0 75.888 0 120v312c0 44.112 35.888 80 80 80h153c11.046 0 20-8.954 20-20s-8.954-20-20-20H80c-22.056 0-40-17.944-40-40V120c0-22.056 17.944-40 40-40h25v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h90v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h91v20c0 11.046 8.954 20 20 20s20-8.954 20-20V80h26c22.056 0 40 17.944 40 40v114c0 11.046 8.954 20 20 20s20-8.954 20-20V120c0-44.112-35.888-80-80-80z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M391 270c-66.72 0-121 54.28-121 121s54.28 121 121 121 121-54.28 121-121-54.28-121-121-121zm0 202c-44.663 0-81-36.336-81-81s36.337-81 81-81 81 36.336 81 81-36.337 81-81 81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420 371h-9v-21c0-11.046-8.954-20-20-20s-20 8.954-20 20v41c0 11.046 8.954 20 20 20h29c11.046 0 20-8.954 20-20s-8.954-20-20-20z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 299,
  cy: 210,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 297,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 210,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 297,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 384,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 384,
  r: 20
}), /*#__PURE__*/React.createElement("circle", {
  cx: 212,
  cy: 210,
  r: 20
}));

function SvgTariffEnd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _ref);
}

export default "/app/dist/assets/tariffEnd.svg";
export { SvgTariffEnd as ReactComponent };